// src/components/SystemRequirements/index.jsx
import { motion } from 'framer-motion';
import './style.scss';
import { requirements } from './systemRequirements';

const SystemRequirements = () => {
  return (
    <motion.div
      className="system-requirements min-vh-100"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.6 },
        },
      }}
    >
      <div className="text-center mb-5">
        <motion.span className="section-badge" whileHover={{ scale: 1.05 }}>
          Requirements
        </motion.span>
        <h2 className="display-6 fw-bold text-primary mb-4">
          System Requirements
        </h2>
        <p className="section-description mx-auto">
          Optimize your experience with these recommended specifications. Our
          application is designed to work efficiently across multiple platforms,
          ensuring smooth operation and maximum productivity.
        </p>
      </div>

      <motion.div className="row px-0 mx-2 g-4 pb-5" layout>
        {requirements.map((system, index) => (
          <motion.div
            className="col-sm-12 col-md-4"
            key={system.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{
              opacity: 1,
              x: Math.sin(index * 0.5) * 3,
              y: Math.cos(index * 0.5) * 3,
            }}
          >
            <motion.div
              className="requirement-card "
              whileHover={{ y: -5, scale: 1.02 }}
              transition={{ duration: 0.3 }}
            >
              <div className="card-header mb-4">
                <system.icon size={24} style={{ color: system.color }} />
                <h3 className="text-primary">{system.name}</h3>
              </div>

              {system.specs.map((spec, index) => (
                <div className="requirement-item" key={index}>
                  <spec.icon
                    className="requirement-icon"
                    size={20}
                    style={{ color: spec.color }}
                  />
                  <div>
                    <div className="text-muted small">{spec.label}</div>
                    <div className="requirement-value">{spec.value}</div>
                  </div>
                </div>
              ))}
            </motion.div>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default SystemRequirements;
